import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import { tileDesktopLayout } from './constants'

const Container = styled(Group)`
  grid-area: primary-content;

  ${tileDesktopLayout} {
    padding: ${rem(20)} 0;
  }
`

interface Props extends React.PropsWithChildren {
}

function CartReviewTilePrimaryContent(props: Props) {
  const {
    children,
  } = props

  return (
    <Container direction="vertical" gap={12}>
      {children}
    </Container>
  )
}

export default CartReviewTilePrimaryContent
